class MenuController {
	static SELECTOR_ANCHOR_HASH = 'a[href$="#"]'
	static SELECTOR_ANCHOR = 'a'
	static SELECTOR_ANCHOR_ROLE_BUTTON = 'a[role="button"]'
	static SELECTOR_MOBILE_TRIGGER = '.mobilemenu__trigger'
	static SELECTOR_NAV_MENU = '.navigation__menu'
	static SELECTOR_MENU_ITEM_HAS_CHILDREN = '.menu-item-has-children'
	static SELECTOR_SUB_MENU = '.sub-menu'
	static SELECTOR_SUB_MENU_WRAP = '.sub-menu-wrap'
	static SELECTOR_NAV_CHILD = '.navigation__child'
	static SELECTOR_NAV_PARENT_OPEN = '.navigation__parent--open'
	static SELECTOR_NAV_CHILD_OPEN = '.navigation__child--open'
	static SELECTOR_NAV_GRANDCHILD = '.navigation__grandchild'
	static ATTR_ROLE = 'role'
	static ATTR_ARIA_EXPANDED = 'aria-expanded'
	static ATTR_ARIA_LABEL = 'aria-label'
	static CLASS_MOBILE_OPEN = 'mobilemenu__open'
	static CLASS_NAV_MENU_OPEN = 'navigation__menu--open'
	static CLASS_NAV_PARENT_OPEN = 'navigation__parent--open'
	static CLASS_NAV_CHILD = 'navigation__child'
	static CLASS_NAV_CHILD_OPEN = 'navigation__child--open'
	static CLASS_NAV_GRANDCHILD = 'navigation__grandchild'

	static PROP_TRUE = 'true'
	static PROP_FALSE = 'false'
	static PROP_MOBILE_MENU_IS_OPEN = 'Close menu'
	static PROP_MOBILE_MENU_IS_CLOSED = 'Open menu'
	static KEYCODE_ESCAPE = 'Escape'

	constructor() {
		document.addEventListener( 'DOMContentLoaded', () => {
			this.setAriaControlsForSubmenus()
			this.initAnchorRoles()
			this.initAnchorRoleButtonToggle()
			this.initMobileMenuTrigger()
			this.initMenuItemHasChildren()
			this.initEscapeKeyHandling()
		} )
	}

	// noinspection FunctionWithMultipleLoopsJS
	setAriaControlsForSubmenus() {
		const menuItems = document.querySelectorAll( MenuController.SELECTOR_MENU_ITEM_HAS_CHILDREN )
		for ( const menuItem of menuItems ) {
			const trigger = menuItem.querySelector( 'a, button' )
			const subMenuWrap = menuItem.querySelector( MenuController.SELECTOR_SUB_MENU_WRAP )
			if ( trigger && subMenuWrap ) {
				trigger.setAttribute( 'aria-controls', subMenuWrap.id )
			}
		}
	}

	// noinspection FunctionWithMultipleLoopsJS
	initAnchorRoles() {
		const anchorsHash = document.querySelectorAll( MenuController.SELECTOR_ANCHOR_HASH )
		for ( const anchor of anchorsHash ) {
			if ( anchor.getAttribute( 'href' ) ) {
				anchor.setAttribute( MenuController.ATTR_ROLE, 'button' )
				anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
			}
		}
		const anchors = document.querySelectorAll( MenuController.SELECTOR_ANCHOR )
		for ( const anchor of anchors ) {
			if ( !anchor.getAttribute( 'href' ) ) {
				anchor.setAttribute( MenuController.ATTR_ROLE, 'button' )
				anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
			}
		}
	}

	initAnchorRoleButtonToggle() {
		const anchors = document.querySelectorAll( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
		for ( const anchor of anchors ) {
			anchor.addEventListener( 'click', function () {
				const expanded = anchor.getAttribute( MenuController.ATTR_ARIA_EXPANDED ) === MenuController.PROP_TRUE
				anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, expanded ? MenuController.PROP_FALSE : MenuController.PROP_TRUE )
			} )
		}
	}

	initMobileMenuTrigger() {
		const triggers = document.querySelectorAll( MenuController.SELECTOR_MOBILE_TRIGGER )
		for ( const trigger of triggers ) {
			trigger.addEventListener( 'click', function ( e ) {
				e.preventDefault()
				const isOpen = trigger.classList.contains( MenuController.CLASS_MOBILE_OPEN )
				trigger.classList.toggle( MenuController.CLASS_MOBILE_OPEN )
				const navMenu = document.querySelector( MenuController.SELECTOR_NAV_MENU )
				if ( navMenu ) {
					navMenu.classList.toggle( MenuController.CLASS_NAV_MENU_OPEN )
				}
				trigger.setAttribute( MenuController.ATTR_ARIA_EXPANDED, isOpen ? MenuController.PROP_FALSE : MenuController.PROP_TRUE )
				trigger.setAttribute( MenuController.ATTR_ARIA_LABEL, isOpen ? MenuController.PROP_MOBILE_MENU_IS_CLOSED : MenuController.PROP_MOBILE_MENU_IS_OPEN )
			} )
		}
	}

	initMenuItemHasChildren() {
		const menuItems = document.querySelectorAll(
			MenuController.SELECTOR_MENU_ITEM_HAS_CHILDREN + ' a[role="button"], ' +
			MenuController.SELECTOR_MENU_ITEM_HAS_CHILDREN + ' button',
		)
		for ( const item of menuItems ) {
			// noinspection FunctionWithMoreThanThreeNegationsJS,FunctionWithMultipleLoopsJS
			item.addEventListener( 'click', function ( e ) {
				e.stopPropagation()
				const parent = item.parentElement
				const isMenuItemHasChildren = parent.classList.contains( 'menu-item-has-children' )
				const isSubMenu = parent.closest( MenuController.SELECTOR_SUB_MENU ) !== null
				if ( isMenuItemHasChildren && !isSubMenu ) {
					e.preventDefault()
					for ( const sibling of parent.parentElement.children ) {
						if ( sibling !== parent ) {
							const subMenuWrap = sibling.querySelector( MenuController.SELECTOR_SUB_MENU_WRAP )
							if ( subMenuWrap ) {
								subMenuWrap.classList.remove( MenuController.CLASS_NAV_CHILD )
							}
							sibling.classList.remove( MenuController.CLASS_NAV_PARENT_OPEN )
							const siblingAnchor = sibling.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
							if ( siblingAnchor ) {
								siblingAnchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
							}
						}
					}
					const subMenuWrap = parent.querySelector( MenuController.SELECTOR_SUB_MENU_WRAP )
					if ( subMenuWrap ) {
						subMenuWrap.classList.toggle( MenuController.CLASS_NAV_CHILD )
					}
					parent.classList.toggle( MenuController.CLASS_NAV_PARENT_OPEN )
					const navGrandchild = document.querySelectorAll( MenuController.SELECTOR_NAV_GRANDCHILD )
					for ( const el of navGrandchild ) {
						el.classList.remove( MenuController.CLASS_NAV_GRANDCHILD )
					}
					const navChildOpen = document.querySelectorAll( MenuController.SELECTOR_NAV_CHILD_OPEN )
					for ( const el of navChildOpen ) {
						for ( const el of navChildOpen ) {
							el.classList.remove( MenuController.CLASS_NAV_CHILD_OPEN )
							const anchor = el.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
							if ( anchor ) {
								anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
							}
						}
					}
				} else if ( isMenuItemHasChildren && isSubMenu ) {
					e.preventDefault()
					for ( const sibling of parent.parentElement.children ) {
						if ( sibling !== parent ) {
							const subMenuWrap = sibling.querySelector( MenuController.SELECTOR_SUB_MENU_WRAP )
							if ( subMenuWrap ) {
								subMenuWrap.classList.remove( MenuController.CLASS_NAV_GRANDCHILD )
							}
							sibling.classList.remove( MenuController.CLASS_NAV_CHILD_OPEN )
							const siblingAnchor = sibling.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
							if ( siblingAnchor ) {
								siblingAnchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
							}
						}
					}
					const subMenuWrap = parent.querySelector( MenuController.SELECTOR_SUB_MENU_WRAP )
					if ( subMenuWrap ) {
						subMenuWrap.classList.toggle( MenuController.CLASS_NAV_GRANDCHILD )
					}
					parent.classList.toggle( MenuController.CLASS_NAV_CHILD_OPEN )
				}
				MenuController.clearMenusOnBodyClick()
			} )
		}
	}

	initEscapeKeyHandling() {
		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key !== MenuController.KEYCODE_ESCAPE ) {
				return
			}

			const activeElement = document.activeElement

			const grandchildWrap = activeElement.closest( '.' + MenuController.CLASS_NAV_GRANDCHILD )
			const childWrap = activeElement.closest( '.' + MenuController.CLASS_NAV_CHILD )
			if ( grandchildWrap ) {
				// Find the child menu item (immediate parent of this grandchild submenu)
				const childMenuItem = grandchildWrap.parentElement.closest( MenuController.SELECTOR_MENU_ITEM_HAS_CHILDREN )
				if ( childMenuItem ) {
					grandchildWrap.classList.remove( MenuController.CLASS_NAV_GRANDCHILD )
					const childListItem = childMenuItem.closest( 'li' )
					const childTrigger = childMenuItem.querySelector( 'a, button' )
					if ( childTrigger ) {
						childTrigger.focus()
						childTrigger.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
						childListItem.classList.remove( MenuController.CLASS_NAV_CHILD_OPEN )
					}
				}

			} else if ( childWrap ) {
				// Find the parent menu item (immediate parent of this child submenu)
				const parentMenuItem = childWrap.parentElement.closest( MenuController.SELECTOR_MENU_ITEM_HAS_CHILDREN )
				if ( parentMenuItem ) {
					const parentListItem = parentMenuItem.closest( 'li' )
					childWrap.classList.remove( MenuController.CLASS_NAV_CHILD )
					const parentTrigger = parentMenuItem.querySelector( 'a, button' )
					if ( parentTrigger ) {
						parentTrigger.focus()
						parentTrigger.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
						parentListItem.classList.remove( MenuController.CLASS_NAV_PARENT_OPEN )
					}
				}
			}
		} )
	}

	static clearMenusOnBodyClick() {
		// noinspection FunctionWithMultipleLoopsJS
		const clear = function () {
			const navParentOpen = document.querySelectorAll( MenuController.SELECTOR_NAV_PARENT_OPEN )
			for ( const el of navParentOpen ) {
				el.classList.remove( MenuController.CLASS_NAV_PARENT_OPEN )
				const anchor = el.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
				if ( anchor ) {
					anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
				}
			}
			const navChild = document.querySelectorAll( MenuController.SELECTOR_NAV_CHILD )
			for ( const el of navChild ) {
				el.classList.remove( MenuController.CLASS_NAV_CHILD )
				const anchor = el.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
				if ( anchor ) {
					anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
				}
			}
			const navChildOpen = document.querySelectorAll( MenuController.SELECTOR_NAV_CHILD_OPEN )
			for ( const el of navChildOpen ) {
				el.classList.remove( MenuController.CLASS_NAV_CHILD_OPEN )
				const anchor = el.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
				if ( anchor ) {
					anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
				}
			}
			const navGrandchild = document.querySelectorAll( MenuController.SELECTOR_NAV_GRANDCHILD )
			for ( const el of navGrandchild ) {
				el.classList.remove( MenuController.CLASS_NAV_GRANDCHILD )
				const anchor = el.querySelector( MenuController.SELECTOR_ANCHOR_ROLE_BUTTON )
				if ( anchor ) {
					anchor.setAttribute( MenuController.ATTR_ARIA_EXPANDED, MenuController.PROP_FALSE )
				}
			}
			document.body.removeEventListener( 'click', clear )
		}
		document.body.addEventListener( 'click', clear )
	}
}

new MenuController()
